import { NgModule } from '@angular/core';
//registe comp add DatePipe
import { CommonModule, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

//COMPONENTS
import { LoginComponent } from 'src/app/tools/login/login.component';
import { SpinnerComponent } from 'src/app/tools/spinner/spinner.component';
import { SimpleModalComponent } from 'src/app/tools/simple-modal/simple-modal.component';
import { PromoStickyComponent } from 'src/app/tools/promo-sticky/promo-sticky.component';
import { LottoBoxComponent } from 'src/app/tools/lotto-box/lotto-box.component';
import { SpecialBoxComponent } from 'src/app/tools/special-box/special-box.component';
import { LogoLottoComponent } from 'src/app/tools/logo-lotto/logo-lotto.component';
import { JackpotComponent } from 'src/app/tools/jackpot/jackpot.component';
import { CountdownComponent } from 'src/app/tools/countdown/countdown.component';
import { CopyComponent } from 'src/app/tools/copy/copy.component';
import { FixedBoxComponent } from 'src/app/tools/fixed-box/fixed-box.component';
import { DiscountProductComponent } from 'src/app/tools/discount-product/discount-product.component';
import { NxnofferComponent } from 'src/app/tools/nxnoffer/nxnoffer.component';
import { PrivatePolicyTemplateSheetModule } from 'src/app/tools/templatesheets/private-policy-template-sheet/private-policy-template-sheet.module';
import { TerminsAndConditionsTemplateSheetModule } from 'src/app/tools/templatesheets/termins-and-conditions-template-sheet/termins-and-conditions-template-sheet.module';

@NgModule({
  declarations: [
    LoginComponent,
    SpinnerComponent,
    SimpleModalComponent,
    PromoStickyComponent,
    LottoBoxComponent,
    SpecialBoxComponent,
    LogoLottoComponent,
    JackpotComponent,
    CountdownComponent,
    CopyComponent,
    FixedBoxComponent,
    NxnofferComponent,
    DiscountProductComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    NgxUsefulSwiperModule,
    MatCardModule,
    MatSlideToggleModule,
    MatBottomSheetModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    TranslateModule,
    PrivatePolicyTemplateSheetModule,
    TerminsAndConditionsTemplateSheetModule
  ],
  providers: [DatePipe],
  exports: [
    LoginComponent,
    NgxUsefulSwiperModule,
    SpinnerComponent,
    SimpleModalComponent,
    PromoStickyComponent,
    LottoBoxComponent,
    SpecialBoxComponent,
    LogoLottoComponent,
    JackpotComponent,
    CountdownComponent,
    CopyComponent,
    FixedBoxComponent,
    NxnofferComponent,
    DiscountProductComponent
  ]
})
export class ToolsModule {}
